import React from 'react'

function RefundIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="21"
      height="23"
      viewBox="0 0 21 23"
      fill="#CBD5E1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.79268 22.0883C8.03229 22.6214 9.37152 22.8844 10.7207 22.8596C12.0699 22.835 13.3984 22.5231 14.6178 21.945C16.83 20.9346 18.5971 19.1514 19.5878 16.9303C21.4336 12.5935 19.7999 6.41694 14.4297 4.13209C12.3462 3.2583 10.024 3.13392 7.85891 3.77978L8.6235 1.716L6.38345 0.888672L4.25674 6.63495L9.78221 9.32292L10.8216 7.17245L8.56964 6.08224L8.56944 6.08245C10.1945 5.60744 11.9327 5.70014 13.4977 6.34516C16.3411 7.53976 19.2738 11.5839 17.3805 16.0073C16.6159 17.6744 15.2798 19.0126 13.6142 19.7796C11.7631 20.6697 9.61634 20.7101 7.73293 19.8901C6.48079 19.3556 5.40349 18.4806 4.62368 17.3644C3.84386 16.2483 3.39281 14.9358 3.32156 13.5762L0.932129 13.7524C1.21588 17.5454 3.40531 20.6486 6.79254 22.0881L6.79268 22.0883Z"
      />
    </svg>
  )
}

export default RefundIcon
